const { Button } = require("@chakra-ui/react");

const SubmitButton = ({
    isDisabled,
    handleClick,
    btnTxt,
    type,
    customClass
}) => {
  return (
    <Button
    className={`submit-btn ${customClass}`}
      variant="brand"
      disabled={isDisabled}
      onClick={(e) => {
        handleClick(e);
      }}
      type={type}
    >
      {btnTxt}
    </Button>
  );
};

export default SubmitButton;